export default {
  header: 'Meidän täytyy vahvistaa puhelinnumerosi',
  remember_device: {
    label: 'Muista tämä laite {{days}} päivää',
  },
  buttons: {
    confirm: 'Vahvista',
  },
  toasts: {
    invalid_code: 'Virheellinen koodi. Yritä uudelleen.',
  },
};
